export const getTodayWithoutTime = () => {
    let currentDate = new Date();
    return new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
}